<template>
    <section class="w-screen h-screen absolute flex justify-center items-center z-50">
        <div id="modal modal-customer" class="modal absolute block w-5/6  bg-white shadow-md rounded-lg" :class="{
            'animate__animated animate__zoomIn': showModal,
            'animate__animated animate__zoomOut': !showModal,
        }">
            <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
                <h5 class="text-white text-center font-bold text-xl">Pelunasan Hutang</h5>
            </div>
            <div id="modal-body"
                class="p-5 max-h-[calc(100dvh-220px)] overflow-y-auto">
                <InputTextCustom v-model="noteCredit" id="note-credit" label="Cara Pelunasan"
                    placeholder="Masukkan cara pelunasan" :valid="validation.note_credit.valid"
                    :error-message="validation.note_credit.message" :isScrolled="true" />
            </div>
            <div class="modal-footer p-5">
                <div class="flex justify-center">
                    <SubmitButton id="close" button_name="Close"
                        button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600"
                        @click="closeModal" />
                    <SubmitButton id="submit" button_name="Submit"
                        button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitFilter" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import SubmitButton from '@/components/form/SubmitButton.vue';
    import InputTextCustom from '@/components/form/InputTextCustom.vue';

    export default {
        name: "FilterCredit",
        props: {
            credit: {
                type: Object,
                default: null,
            }
        },
        components: {
            SubmitButton, InputTextCustom
        },
        data() {
            return {
                showModal: true,
                noteCredit: '',
                validation: {
                    note_credit: {
                        valid: true,
                        message: ''
                    }
                }
            }
        },
        created(){
            if (this.credit) {
                this.noteCredit = this.credit?.note_credit;
            }
        },
        methods: {
            closeModal() {
                this.showModal = false;
                setTimeout(() => {
                    this.$emit('closeModal');
                }, 200);
            },
            submitFilter() {
                const save = {
                    ...this.credit,
                    note_credit: this.noteCredit
                }
                this.$emit('submitPelunasan', save);
                this.closeModal();
            }
        }
    }
</script>